import { GroupShareContextQueryDocument } from "@pathwright/graphql-client/src/generated"

export default GroupShareContextQueryDocument
